<template>
  <div class="page px-3" v-if="visible">
    <div>
      <h4 class="function-title">Certificado de Cobertura Actualizado</h4>
    </div>
    <b-row>
      <b-col sm="8" offset-sm="2">
        <b-row>
          <b-col sm="6">
            <p>
              <b class="text-primary">Póliza:</b>
              {{ nroPoliza }}
            </p>
            <p>
              <b class="text-primary">Asegurado:</b>
              {{ nombreAsegurado }}
            </p>
          </b-col>
          <b-col sm="6">
            <b-dropdown v-if="ramo == 10" variant="outline-primary" text="Cláusula de No Repetición" class="w-100 mb-2 btn-no-repeticion">
              <b-dropdown-item @click="openEmpAsoc"> <i class="fas fa-building"></i>Empresas vigentes en Póliza</b-dropdown-item>
              <b-dropdown-item @click="openNuevaEmpresaAsoc"> <i class="fas fa-plus"></i>Agregar Empresas nuevas a esta poliza</b-dropdown-item>
            </b-dropdown>
          <b-row>
            <b-col>
            <span class="empresas-elegidas" style="text-align: center" v-if="empresasElegidas.length > 0">
              Cantidad de empresas nuevas seleccionadas: {{ empresasElegidas.length }}
              <b-button variant="danger" @click="limpiarEmpresasElegidas">Limpiar</b-button>
            </span>
            
            </b-col>
          </b-row>  
          </b-col>
          <b-col sm="12">
            <!-- <p>Mantener presionado el boton Ctrl (windows) o Command (Mac) para hacer una seleccion multiple</p> -->
            <p class="text-primary" v-if="asegurados.length > 0">
              <b>Nro de Ítem / Nombre:</b>
              <!-- <b-form-select multiple :disabled="itemsVigentes" class="mt-2" :options="asegurados" v-model="asegurado" /> -->
              <v-select
                multiple
                v-model="asegurado"
                label="text"
                class="mt-2"
                :options="asegurados"
                :disabled="itemsVigentes"
                :reduce="asegurados => asegurados.value"
              ></v-select>
            </p>
          </b-col>
              Cantidad de seleccionados: {{ asegurado.length }}
          <b-col sm="12" v-if="asegurados.length > 1">
              <b-form-checkbox @input="asegurado = []" v-model="itemsVigentes" title="Se detallaran los items vigentes en el certificado.">Seleccionar todos los asegurados</b-form-checkbox>
          </b-col>
        </b-row>
        <div class="submit-footer">
          <b-row>
            <b-col></b-col>
            <b-col class="text-right">
              <b-tooltip target="cert-btn" triggers="hover">La descarga del presente certificado se notificará a la compañía</b-tooltip>
              <b-btn id="cert-btn" variant="primary" @click="descargarCertificado" 
                     :disabled="(!asegurado.length && !itemsVigentes) || 
                                $refs.VerEmpresasAsociadas.visible || 
                                $refs.NuevasEmpresasAsociadas.visible">
                <i class="fa fa-check" v-if="!sending"></i>
                <i class="fa fa-spinner fa-spin" v-else></i>
                Descargar Certificado
              </b-btn>
            </b-col>
          </b-row>
        </div>
        <br><br>
      </b-col>
    </b-row>

  <ver-empresas-asociadas
    id="ver-empresas-asociadas"
    ref="VerEmpresasAsociadas"
    :nro-poliza="nroPoliza"
    :nro-endoso="nroEndoso"
    @cerrar="cerrarModEmpresas"
    @limpiar="limpiarEmpresasElegidas"
  />

  <nuevas-empresas-asociadas
    id="nuevas-empresas-asociadas"
    ref="NuevasEmpresasAsociadas"
    :nro-poliza="nroPoliza"
    @cerrar="cerrarModNuevasEmpresas"
    @enviar="enviarNuevasEmpresas"
  />

  </div>
</template>

<script>
import VerEmpresasAsociadas from '@/components/VerEmpresasAsociadas';
import NuevasEmpresasAsociadas from '@/components/NuevasEmpresasAsociadas';

export default {
  components: {
    VerEmpresasAsociadas,
    NuevasEmpresasAsociadas,
  },
  props: {
    nroPoliza: {
      type: Number | String
    },
    codAgente: {
      type: Number | String
    },
    nombreAsegurado: {
      type: String
    },
    tomador: {
      type: Number | String
    },
    nomTomador: {
      type: String
    },
    nroEndoso: {
      type: Number | String
    },
    ramo: {
      type: Number | String
    },
    grupal: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      visible: false,
      asegurados: [],
      asegurado: [],
      empresasElegidas: [],
      sending: false,
      itemsVigentes: false,
      refreshEmpresasAsociadas: false,
      refreshNuevasEmpresas: false,
    };
  },
  methods: {
    openEmpAsoc() {      
      this.refreshEmpresasAsociadas = true
      this.$refs.VerEmpresasAsociadas.visible = true;
      this.cerrarModNuevasEmpresas()
      setTimeout(() => {
        location.hash = '#ver-empresas-asociadas';
      });
    },
    openNuevaEmpresaAsoc() {
      this.refreshNuevasEmpresas = true
      this.$refs.NuevasEmpresasAsociadas.visible = true;
      this.cerrarModEmpresas()
      setTimeout(() => {
        location.hash = '#nuevas-empresas-asociadas';
      });
    },
    cerrarModEmpresas(){
      this.refreshEmpresasAsociadas = false
      this.$refs.VerEmpresasAsociadas.visible = false
    },
    cerrarModNuevasEmpresas(){
      this.refreshNuevasEmpresas = false
      this.$refs.NuevasEmpresasAsociadas.visible = false;
    },
    enviarNuevasEmpresas(item){
      this.cerrarModNuevasEmpresas()

      // Las empresas elegidas se guardan en un data para enviarse al certificado
      this.empresasElegidas = item
    },
    limpiarEmpresasElegidas(){
      this.empresasElegidas = []
    },
    descargarCertificado: async function() {
      this.sending = true;
      const payload = {
        cod_ramo: this.ramo,
        cod_tomador: this.tomador,
        nro_pol: this.nroPoliza,
        nro_endoso: this.nroEndoso,
        aseg: this.asegurado,
        empresas: this.empresasElegidas,
        itemsVigentes: this.itemsVigentes        
      };
      await this.$api({
        url: 'endoso/certificado',
        method: 'POST',
        responseType: 'blob',
        data: payload
      }).then(res => {
        var a = document.createElement("a")
        document.body.appendChild(a)
        a.style="display: none"
                
        
        /*const file = new Blob([texto], {
            type: "text/plain",
        });*/

        if (res.statusText!='' && res.statusText.toLowerCase() != 'ok'){
          this.$toast.warning('No fue posible recuperar Cláusula de no repetición original de Póliza. Incluirla como Empresa Nueva');
          if (res.statusText == 'Error 1') {
            this.$toast.success('Se generó certificado con Cláusula de no repetición con las empresas seleccionadas');
          }  
        } 

        const fileURL = URL.createObjectURL(res.data);
        a.href = fileURL
        var docAsegurado = ""
        if(this.asegurado.length === 1) {
          // //console.log("documento de asegurado: " + this.asegurado[0][2])
          docAsegurado = "-" + this.asegurado[0][2]
        }else if(this.asegurado.length > 1 || this.itemsVigentes){
          // //console.log("el doc es general para todos")
          docAsegurado = "-GENERAL"
        }
        a.download = this.ramo + "-" + this.nroPoliza + "-" + this.nroEndoso + "-" + this.codAgente + "-"
                    + this.nomTomador.trim() + docAsegurado + ".pdf"
        // //console.log("nombre de descarga: " + a.download)
        a.click();
        window.URL.revokeObjectURL(fileURL);
        document.body.removeChild(a);
      })/*.catch(err => {
        const toast = this.$toast;
        const fr = new FileReader();
        fr.onload = function() {
          toast.error('No se puede descargar el certificado. ' + fr.result.replace(/"/g, ''));
        };
        fr.readAsText(err.response.data);
      })*/;

      this.sending = false;
    }
  },

  watch: {
    visible(val) {
      if (val) {
        let load = this.$loading.show();
        this.$api(`polizas/asegurados/${this.nroPoliza}/${this.nroEndoso}`)
            .then(res => {
          //console.log(res.data);
          load.hide();
          this.asegurados = res.data.map(item => {            
            return {
                    text: 'Aseg. Nro.: ' + item.nro_item + ' | Doc.: ' + item.documento + ' | Nombre: ' + item.nombre,
                    value: [item.cod_aseg, item.nro_item, item.documento, item.endoso]
                   };
          });
          /** Selecciono el único asegurado x defecto */
          if (this.asegurados.length === 1) {
            this.asegurado[0] = this.asegurados[0].value;
          }
        });
      }
    }
  }
};
</script>
